import axiosClient from "../axios-client";
import { client } from "./generated/client.gen";
import {
  BillingAccountsApi,
  ConfigurationApi,
  CountriesApi,
  FulfillmentsApi,
  LegalTermsApi,
  LicensesApi,
  OrderTaxEstimatesApi,
  OrdersApi,
  PlansApi,
  RateCardsApi,
  SubscriptionBillingAccountApi,
  SubscriptionRateCardsApi,
  SubscriptionsApi,
} from "./generated/sdk.gen";

// Requests go through our axios instance for the bearer token, the 401 retry, and DateTime
// deserialization.
client.setConfig({
  axios: axiosClient,
  // The SDK concatenates this with the operation path rather than letting axios combine them, so a
  // trailing slash would produce "//v2/..." and miss every route.
  baseURL: process.env.API_URL?.replace(/\/+$/, ""),
  // Endpoints that bind a complex type from the query string expect its properties spelled out
  // flat (`id=..&autoRenewPeriod=..`), not as deepObject (`request[id]=..`), which is the default.
  querySerializer: { object: { style: "form", explode: true } },
});

export * from "./generated";

// One instance per API area, each talking to the client configured above. Call endpoints through
// these rather than constructing an Api class at the call site.
export const billingAccountsApi = new BillingAccountsApi();
export const configurationApi = new ConfigurationApi();
export const countriesApi = new CountriesApi();
export const fulfillmentsApi = new FulfillmentsApi();
export const legalTermsApi = new LegalTermsApi();
export const licensesApi = new LicensesApi();
export const orderTaxEstimatesApi = new OrderTaxEstimatesApi();
export const ordersApi = new OrdersApi();
export const plansApi = new PlansApi();
export const rateCardsApi = new RateCardsApi();
export const subscriptionBillingAccountApi = new SubscriptionBillingAccountApi();
export const subscriptionRateCardsApi = new SubscriptionRateCardsApi();
export const subscriptionsApi = new SubscriptionsApi();

// Re-export auto-renewal period utilities (but not the AutoRenewPeriod type - use generated version)
export { normalizeAutoRenewPeriod, getAutoRenewPeriodLabel } from "./auto-renew-period";

// Re-export lifecycle type utilities (but not the LifecycleType type - use generated version)
export { reactivatableLifecycleTypes } from "./lifecycle-type";
